import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import { redirectIfNoPermission } from 'cio/utils/route-access';
import ConfirmChangesService from 'cio/services/confirm-changes';
import EditController from './controller';
import CustomerModel from 'cio/models/customer';

export default class EditRoute extends Route {
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Edit',
      path: this.routeName,
    };
  }

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);

    return redirectIfNoPermission(this, 'journeys/people/edit', transition);
  }

  setupController(controller: EditController, model: CustomerModel, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.prepareAttributesProxy();
    this.confirmChanges.register(controller, this);
  }
}
